import Setup from './Setup';
import CarditExport from './CarditExport';
import CarditImport from './CarditImport';
import InboundCjid from './InboundCjid';
import Client from './Client';
import User from './User';
import Agent from './Agent';
import Resdit from './Resdit';
import Flight from './Flight';
import RoadClient from './RoadClient';
import Postoffice from './Postoffice';
import Dashboard from './Dashboard';
import Charges from './Charges';
import File from './File';
import Scan from './Scan';
import Ulds from './Ulds';

const Components = {
    Setup : Setup,
    CarditExport,
    CarditImport,
    InboundCjid,
    Scan,
    Client : Client,
    User : User,
    Agent : Agent,
    Resdit : Resdit,
    Flight,
	RoadClient,
	Postoffice,
    Dashboard,
    Charges,
    File,
    Ulds
}

export default Components;